import { adapter } from '@seek/tealium-adapter';

import { allTrackingState, type InitialAppState } from './analytics';

const tealium = adapter();

interface TrackLinkProps {
  eventName: string;
  currentPage?: string;
  currentPageSection: string;
  isExitLink?: boolean;
  passwordlessAuthentication?: string;
  identityProvider?: string;
  authenticationFlow?: string;
  alertShownType?: string;
  alertShownPosition?: string;
  alertShownTitle?: string;
  alertShownMessage?: string;
  linkText?: string;
  linkPosition?: string;
  isThirdPartyLink?: string;
}

export const createAccountAnalytics = (initialState: InitialAppState) => {
  const trackAccountLink = (props: TrackLinkProps) => {
    const { eventName } = props;
    const trackingfields = {
      ...initialState,
      ...allTrackingState(),
      ...props,
      currentPage: 'account settings',
    };
    tealium.link(eventName, trackingfields);
  };

  return {
    trackAccountLink,
  };
};

export type AccountAnalytics = ReturnType<typeof createAccountAnalytics>;
